import axios from "axios";
import { AllDeviceTableDataType } from "../constants/types";

export const getGroupData = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/device/site/quantity`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    const totalValue = res.data.pop();

    return {
      total: {
        total: totalValue.total,
        disConnected: totalValue.disconnectedDevice,
      },
      list: res.data,
    };
  } catch (e) {
    console.log(e);
    return {
      total: {
        total: 0,
        disConnected: 0,
      },
      list: [],
    };
  }
};

export const getAllDeviceList = async (
  page: number,
  size: number,
  siteNo: string,
  type: string
) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/device/list?page=${page}&size=${size}${
        siteNo === "all" ? "" : "&siteNo=" + siteNo
      }${type === "all" ? "" : "&type=" + type}`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    const data: AllDeviceTableDataType[] = res.data.items.map((data: any) => ({
      status: data.connected,
      no: data.no,
      projectName: data.project,
      category: data.category,
      id: data.id,
      name: data.name,
      lastDate: data.lastConnectedTime,
      note: data.note,
    }));

    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
